<template>
  <div class="global-menu-about mt-5">
    <div class="mb-5 text-center" v-if="$route.name != 'list' && $route.name != 'home.embed' && !isEmbedded">
      <BButton variant="light" size="lg" class="p-2 d-inline-block" @click="backPage()">
        <IconArrowLeft :width="24" :height="24" /> 
        <span class="d-none d-md-inline">
          {{ $t('list.back') }}
        </span>
      </BButton>
    </div>

    <BCard no-body class="mb-1 d-none d-md-block">
      <div class="note p-3 text-center">
        {{ $t('list.disclaimer_note') }} 
        <br />
        <RouterLink :to="{ name: 'about.page' }" class="border-none d-inline flex-rows align-items-center justify-content-center">
          {{ $t('list.more') }}
        </RouterLink>
      </div> 
      <RouterLink :to="{ name: 'about.page' }" class="border-none d-flex p-3 mb-3 flex-rows align-items-center justify-content-center">
        <IconInfo class="mr-2" />
        {{ $t('list.about_link') }}
      </RouterLink>
    </BCard>
  </div>
</template>


<style lang="scss">
  .global-menu-about {
    pointer-events: all;

    .note {
      font-size: 18px;
    }
  }
</style>

<script>
  import IframeResizer from '@icij/murmur/lib/utils/iframe-resizer'
  import IconInfo from '@/components/IconInfo'
  import IconArrowLeft from '@/components/IconArrowLeft'

  export default {
    name: 'AboutLinks',
    components: {
      IconInfo,
      IconArrowLeft
    },
    props: {
      openContent: [Boolean, String]
    },
    computed: {
      isEmbedded () {
        return IframeResizer.isEmbedded()
      }
    },
    methods: {
      backPage() {
        setTimeout(() => {
          window.history.back()
        }, 100)
      }
    }
  }

</script>